// 工具函数：获取 HTML 根元素 font-size（全局 rem 基准值）
export const getRootFontSize = () => {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 100;
};
// 工具函数：将 rem 系数转换为实际像素（核心适配逻辑）
export const rem2px = (rem) => {
    return Math.floor(rem * getRootFontSize());
};
// 工具函数：将 rem 系数转换为实际像素（核心适配逻辑）
export const REM_CONFIG = {
    rowHeight: 0.27, // 表格行高系数（原 27px）
    barBorderRadius: "0.02rem",
    fontSize: {
        normal: "0.14rem", // 普通文本（单位、下拉框）系数（原 14px）
        small: "0.13rem", // 小文本（下拉图标旁）系数（原 12px）
    },
    spacing: {
        top: 0.4,
        mb: 0.03,
        mt: 0.03,
        paddingX: 0.16,
        scrollStep: 1,
    },
};
